import { filter, pipe } from "callbag-basics";
import subscribe from "callbag-subscribe";
import { FC, useEffect } from "react";

import { Alert, Button, Modal, SpacingToken } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { actions$ } from "store/action-stream";
import { SUBSCRIPTION } from "store/entities/subscriptions";
import { IAction } from "store/helper";
import { withVar } from "themes/helpers";

interface IProps {
  onClose: () => void;
  onImportStart: () => void;
}

const AgentsAndGroupsImportModal: FC<IProps> = ({ onClose, onImportStart }) => {
  const handleImportClick = (): void => {
    onImportStart();
    onClose();
  };

  useEffect(() => {
    const unsubscribe = pipe(
      actions$,
      filter((action: IAction) => action.type === SUBSCRIPTION.UPDATE.SUCCESS),
      subscribe(() => {
        onImportStart();
        onClose();
      })
    );
    return unsubscribe;
  }, []);

  return (
    <Modal
      heading="Import LiveChat agent and groups"
      onClose={onClose}
      footer={
        <Flex gap={withVar(SpacingToken.Spacing2)}>
          <Button kind="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button kind="primary" onClick={handleImportClick}>
            Import
          </Button>
        </Flex>
      }
      css={{ maxWidth: "600px" }}
    >
      <Alert>
        Imported LiveChat users will keep their roles in HelpDesk and <b>be billed per the chosen HelpDesk plan.</b>
      </Alert>
    </Modal>
  );
};

export { AgentsAndGroupsImportModal, type IProps as IAgentsAndGroupsImportModalProps };
